module.exports = __webpack_public_path__ + "fonts/KaTeX_Math-BoldItalic.6589c4f1.ttf";